import styled from 'styled-components';
import { MachineSpecTable } from '../../../../../components/common/machine/MachineSpecTable';
import { TabContainer } from '../../../../../components/common/tab/TabContainer';
import { useGetDictionaryUnitMapQuery } from '../../../../../hooks/api/dictionary/queries/useGetDictionaryUnitMap.query';
import { useGetDictionaryWordMapQuery } from '../../../../../hooks/api/dictionary/queries/useGetDictionaryWordMap.query';
import { IProduct } from '../../../../../interfaces/Product.interfaces';
import { ProductOptionSection } from './ProductOptionSection';
import { SectionTitle } from './SectionTitle';
import { ampli } from '../../../../../ampli';
import ReactGA from 'react-ga4';

interface ProductOptionAndMachineTableSectionProps {
  product: IProduct;
}

export const ProductOptionAndMachineTableSection = ({ product }: ProductOptionAndMachineTableSectionProps) => {
  const { data: unitMap } = useGetDictionaryUnitMapQuery();
  const { data: wordMap } = useGetDictionaryWordMapQuery();

  return (
    <Container>
      <SectionTitle>{'매물 정보'}</SectionTitle>

      <ProductInfo>
        <TabContainer
          tabInfos={[
            {
              text: '옵션',
              element: <ProductOptionSection activedProductOptions={product.options} />,
            },
            {
              text: '제원',
              handleTabClick: () => {
                ampli.pvmClickMachineSpecificationsTab();
                ReactGA.event('pvm_click_machine_specifications_tab');
              },
              element:
                unitMap && wordMap ? (
                  <MachineSpecTable
                    machineData={product.machine}
                    unitMap={unitMap}
                    wordMap={wordMap}
                    type={'long'}
                    onProductDetail
                  />
                ) : (
                  <></>
                ),
            },
          ]}
        />
      </ProductInfo>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  gap: 24px;
  padding: 32px var(--radius-large, 16px);
`;

const ProductInfo = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: 24px;
`;
